angular.module('bribac.components.externalMonitorEditor', [
  'bribac.values',
  'bribac.translations'
])

  .component('externalMonitorEditor', {
    templateUrl: 'external-monitor-editor-component.html',
    controller: 'ExternalMonitorEditorComponentCtrl',
    bindings: {
      externalMonitor: '<',
      successCallback: '<',
      cancelCallback: '<'
    }
  })

  .controller('ExternalMonitorEditorComponentCtrl', function(
    PHONE_NUMBER_REGEX
  ) {
    var $ctrl = this

    $ctrl.PHONE_NUMBER_REGEX = PHONE_NUMBER_REGEX

    $ctrl.onSubmit = function() {
      var $form = $ctrl.form

      if ($form._submitting) return
      if ($form.$invalid) {
        $form._submitError = 'formErrors.invalidFields'
        return
      }

      $ctrl.successCallback($ctrl.editableExtMonitor)
    }

    $ctrl.$onChanges = function(changes) {
      if (changes.externalMonitor) {
        // Reset state since the external monitor instance we're editing has changed.
        $ctrl.editableExtMonitor = angular.copy($ctrl.externalMonitor)
      }
    }
  })
